import { isInApp, actFBAuthorization } from './appSDK'

export function install () {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve(window.FB)
      return
    }

    ;(function (d, s, id) {
      let js
      const fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) { return }
      js = d.createElement(s)
      js.id = id
      js.src = '//connect.facebook.net/zh_CN/sdk.js#xfbml=1&version=v3.1'
      fjs.parentNode.insertBefore(js, fjs)
    // console.log('setting fb sdk')
    }(document, 'script', 'facebook-jssdk'))

    window.fbAsyncInit = function onSDKInit () {
      window.FB.init({
        appId: '264229304591551',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v6.0'

        // appId: '916696735042825',
        // autoLogAppEvents: true,
        // cookie: true,
        // xfbml: true,
        // version: 'v2.8'
      })
      resolve(window.FB)

    // 記錄用戶行為資料 可在後台查看用戶資訊
    // window.FB.AppEvents.logPageView()
    }
  })
}

export async function getAccessToken () {
  if (isInApp()) {
    return actFBAuthorization()
  }
  await install()
  return new Promise((resolve, reject) => {
    window.FB.login(function (loginResponse) {
      const status = loginResponse.status
      if (status === 'connected') {
        resolve(loginResponse.authResponse.accessToken)
      } else {
        reject(loginResponse)
      }
    }, { scope: 'email' })
  })
}
